import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-roles-new-role',
  templateUrl: './roles-new-role.component.html',
  styleUrls: ['./roles-new-role.component.scss']
})
export class RolesNewRoleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
